<template>
  <md-progress-spinner v-if="visible" class="accent" :md-stroke="3" md-mode="indeterminate" id="loading-spinner"></md-progress-spinner>
</template>

<script>
export default {
  name: 'AppLoading',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/AppLoading.vue